"use strict";
export default {
  setUserFilterPreference(location, history) {
    const filters = location.query.filters || this.userPreferredFilter();
    let query = { filters };
    let name = Auth._currentUser.name;
    if (name === "HubTran Admin" || name === "TriumphPay Admin") {
      query.page = location.query.page || 1;
    }
    history.pushState(
      null,
      location.pathname,
      query
    );
  },
  selectedFilters(location) {
    return location.query.filters || {};
  },
  userPreferredFilter() {
    return Auth._currentUser.settings.preferred_filter || { "All": "true" };
  },
  queryWithFilters(filters) {
    return _.extend({}, { filters });
  }
};
